import { Spin } from "antd";
import { OverviewGroupSummary } from "Services/Api/Dashboard/Types";
import { renderScoreCell, renderTagCell } from "./columns";
import styles from './GroupSummaryTable.module.scss';
import { useTranslation } from "react-i18next";
import { FEATURE_ACCESS_TYPE } from "FeatureManager/FeatureManager.type";

const TableDataCard = ({ data, loading, featureAccess }: { data: OverviewGroupSummary, loading: boolean, featureAccess: FEATURE_ACCESS_TYPE }) => {
    const { t } = useTranslation();

    return <Spin spinning={loading} wrapperClassName={styles.loadingCard}>
        <div className={styles.cardMobileView}>
            <div className={styles.heading}>{data?.groupName || ''}</div>
            <div>
                {featureAccess.phishing && <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.phishing')}</div>
                    {renderScoreCell(data?.phishingScore ?? 0)}
                </div>}
                {featureAccess.training && <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.training')}</div>
                    {renderScoreCell(data?.elearningScore ?? 0)}
                </div>}
                {featureAccess.saqCompliance && <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.saqCompliance')}</div>
                    {renderTagCell(data?.saqStatus ?? "", t)}
                </div>}
                {featureAccess.scanning && <div className={styles.row}>
                    <div className={styles.label}>{t('newDashboard.summaryTable.headers.scanning')}</div>
                    {renderTagCell(data?.scanningStatus ?? "", t)}
                </div>}
            </div>
        </div>
    </Spin>
}

export default TableDataCard;